import { useState } from 'react';

import PropTypes from 'prop-types';

import { useTransl } from 'shared/lib/i18n';

import CallCenterVisitorComponent from './CallCenterVisitorComponent';

import { OPEN_VENDOR, REJECT_VISITOR } from './constants';

import { CUSTOM } from '../Modal/modalTypes';

const CallCenterVisitorContainer = (props) => {
  const { t } = useTransl();
  const { visitors, building, accessPoint, openAccessPointForVisitor } = props;
  const { visitorPhotoRequired, allowOpenVendors, openVendorNote } =
    building || {};

  const [modal, setModal] = useState({ type: null, data: null });

  const onModalShow = (type, data) => {
    setModal({ type, data });
  };
  const onModalClose = () => {
    setModal({ type: null, data: null });
  };

  const onOpenAccessPointForVisitor = (visitorId) => {
    openAccessPointForVisitor(accessPoint, { id: visitorId });
    onModalClose();
  };

  const modalProps = {
    modal: {
      modalType: CUSTOM,
      modalProps: {
        title:
          modal?.type === REJECT_VISITOR
            ? t('visitor.rejectVisitor')
            : modal?.type === OPEN_VENDOR
            ? t('title.unlistedVendor')
            : t('title.visitor'),
      },
    },
    onModalClose,
  };

  return (
    <CallCenterVisitorComponent
      visitors={visitors}
      allowOpenVendors={allowOpenVendors}
      openVendorNote={openVendorNote}
      modal={modal}
      modalProps={modalProps}
      onModalShow={onModalShow}
      onOpenAccessPointForVisitor={onOpenAccessPointForVisitor}
      disableIfNoPhoto={visitorPhotoRequired}
    />
  );
};

CallCenterVisitorContainer.propTypes = {
  visitors: PropTypes.instanceOf(Array).isRequired,
  building: PropTypes.instanceOf(Object).isRequired,
  openAccessPointForVisitor: PropTypes.func.isRequired,
  accessPoint: PropTypes.instanceOf(Object).isRequired,
};

export default CallCenterVisitorContainer;
